export const HOVERED_PROJECT_TARGET = 'hoveredProjectId';
export const SELECTED_PROJECT_TARGET = 'selectedProjectId';
export const PROJECTS_TARGET = 'projects';

export const STATE_DESCRIPTION = {
  [PROJECTS_TARGET]: null,
  [HOVERED_PROJECT_TARGET]: null,
  [SELECTED_PROJECT_TARGET]: null
};
